'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { usePostHogBoolFlag } from '@workspace/analytics/posthog/feature-flags-client';
import { useUserVerification } from '@/hooks/use-user';
import { buildOrganisationSwitcherItems } from '@/lib/organisation-switcher-items';
import { useAuthStore } from '@/stores/authStore';

export function useCanShowMultiOrganisationSwitcher(): boolean {
  const showMultiOrgs = usePostHogBoolFlag('show-multi-orgs', false);
  const user = useAuthStore((state) => state.user);
  const userId = user?.user.id;

  const { data: userVerification } = useUserVerification(!!userId && showMultiOrgs);

  if (!showMultiOrgs) {
    return false;
  }

  return buildOrganisationSwitcherItems(userVerification?.organisations ?? []).length >= 2;
}
